import React from 'react'
import { Popup } from '../../../../../components/Popup'
import { Box, Text } from '../../../../../designSystem'
import '../chapterAddEdit.css'

function HasUnsavedChanges({ 
    hasUnsavedChanges, 
    setHasUnsavedChanges, 
    removeUnsavedChangesHandler,  
    addUnsavedChangesHandler
}) {
  return (
    <Popup
      show={hasUnsavedChanges}
      close={() => setHasUnsavedChanges(false)}
      renderActions={
        <>
          <button
            className="action-button"
            type="button"
            onClick={removeUnsavedChangesHandler}
          >
            No
          </button>
          <button
            className="action-button primary"
            type="button"
            onClick={addUnsavedChangesHandler}
          >
            Yes
          </button>
        </>
      }
    >
      <Box
        variant="flex"
        alignItems="center"
        mb={8}
        justifyContent="flex-start"
      >
        <Text variant="titleSecondary">Warning</Text>
      </Box>
      <Text variant="caption" lineHeight={1.8} fontWeight={500}>
        We have some unsaved changes of yours. Do you want them?
      </Text>
    </Popup>
  )
}

export default HasUnsavedChanges